<template>
    <id-dispenser prefix="settings">
        <template v-slot="{id}">
            <div class="row mb-2">
                <div :class="`col-${colSize}`">
                    <div class="row">
                         <div class="col-12">        
                            <label :for="id">
                                {{label}}
                            </label>
                         </div>
                    </div>
                    <slot name="extra">

                    </slot>
                </div>
                <div :class="`col-${contentColSize}`">
                    <slot :id="id">

                    </slot>
                </div>
            </div>
        </template>
    </id-dispenser>
</template>

<script>
    import IdDispenser from "../../../../../Components/Util/IdDispenser.vue";

    export default {
        name: 'journey-brick-settings-property',
        components: {
            IdDispenser
        },
        computed: {
            contentColSize() {
                return 12 - this.colSize;
            }
        },
        props: {
            label: {
                type: String,
                default: ''
            },
            colSize: {
                type: Number,
                default: 4
            }
        }
    };
</script>